import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { PersonalOfferInfoModel, PersonalOfferListItem } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Flex from 'components/Layout/components/Flex';
import { Button } from 'components/Button';
import { useTranslation } from 'react-i18next';
import { CloseOffers, ShowAllOffers } from 'autogen/translation-keys/trans-website-personaloffer';
import OfferItem from './offerItem';

const StyledHeading = styled(Typography.Body)`
    margin-bottom: ${Spacing8};
`;

const OfferList = styled.div<{ $isExpanded: boolean }>`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${Spacing8};
    margin-bottom: ${Spacing8};
    width: 100%;

    ${({ $isExpanded }) =>
        !$isExpanded &&
        css`
            & div:nth-of-type(1n + 4) {
                display: none;
            }
        `}
`;

export interface IPersonalOffers {
    model: PersonalOfferInfoModel;
}

export default function PersonalOffers({ model }: IPersonalOffers): JSX.Element {
    const { heading, subtext, offers } = model;
    const { t } = useTranslation();

    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Flex.Column>
            <StyledHeading size="M" strong>
                {heading}
            </StyledHeading>
            <Flex.Column alignItems="center" gap={Spacing8}>
                <OfferList $isExpanded={isExpanded}>
                    {offers.map(
                        (offer: PersonalOfferListItem): JSX.Element => (
                            <OfferItem {...offer} key={offer.discountId} />
                        )
                    )}
                </OfferList>
                {offers.length > 3 && (
                    <Button variant="primaryText" onClick={() => setIsExpanded((prev) => !prev)}>
                        {isExpanded ? t(CloseOffers) : t(ShowAllOffers)}
                    </Button>
                )}
            </Flex.Column>

            <Typography.Body>{subtext}</Typography.Body>
        </Flex.Column>
    );
}
